<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Ana Araç Tipi</label>
            <v-select-list v-model="baseType" disabled label="Name" placeholder="Ana Araç Tipi" :options="vehicleTypeBaseTypes" />
        </div>
        <div class="col-12 mb-1" v-if="value.ParentVehicleTypeId">
            <label class="form-label">Üst Grup</label>
            <v-select-list v-model="type" disabled label="Name" placeholder="Üst Grup" :options="parentVehicleTypes" />
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Tip</label>
            <input type="text" class="form-control" placeholder="Tip" v-model="value.Name" />
        </div>
        <div class="col-12 mb-1" v-if="!value.ParentVehicleTypeId">
            <label class="form-label">Kod</label>
            <input type="text" class="form-control" placeholder="Kod" v-model="value.Code" />
        </div>
        <div class="col-12 mb-1">
            <b-form-checkbox v-model="value.IsCanBeConnectToTruck">Kamyona Bağlanabilir Mi?</b-form-checkbox>
        </div>
        <div class="col-12 mb-1">
            <b-form-checkbox v-model="value.IsNeedHGS">HGS Etiketi Zorunlu</b-form-checkbox>
        </div>
        <div class="col-12 mb-1" v-if="value.IsCanGroupNumberDefinable">
            <label class="form-label">Grup Numarası</label>
            <input type="number" class="form-control" placeholder="Grup Numarası" v-model="value.GroupNumber" />
        </div>
        <div class="col-12">
            <label class="form-label">Resim</label>
            <v-file-uploader v-model="value" :accept="['png', 'jpg', 'jpeg']" valueParameter="Image"></v-file-uploader>
        </div>
    </div>
</template>

<script>
import VehicleDefinitionsApi from "@/api/vehicle-definitions";
import VFileUploader from "@/components/v-file-uploader/VFileUploader.vue";
import Additional from "@/utilities/additional";
import { BFormCheckbox } from "bootstrap-vue";

export default {
    components: {
        VFileUploader,
        BFormCheckbox,
    },
    props: {
        value: Object,
    },
    data() {
        return {
            parentVehicleTypes: [],
            vehicleTypeBaseTypes: [],
        };
    },
    mounted() {
        this.getParentVehicleTypes();
        this.getVehicleTypeBaseTypes();
    },
    methods: {
        getParentVehicleTypes() {
            VehicleDefinitionsApi.Type.List().then((res) => {
                this.parentVehicleTypes = Additional.ConvertNestedDataToSingleData(res.data.Data, "Name", "Id", "ParentVehicleTypeId");
            });
        },
        getVehicleTypeBaseTypes() {
            VehicleDefinitionsApi.BaseType.List().then((res) => {
                this.vehicleTypeBaseTypes = res.data.Data;
            });
        },
    },
    computed: {
        type: {
            get: function () {
                return this.parentVehicleTypes.find((b) => b.Id == this.value.ParentVehicleTypeId);
            },
            set: function (value) {
                this.value.ParentVehicleTypeId = value?.Id || this.value.ParentVehicleTypeId;
            },
        },
        baseType: {
            get: function () {
                return this.vehicleTypeBaseTypes.find((b) => b.Id == this.value.VehicleTypeBaseTypeId);
            },
            set: function (value) {
                this.value.VehicleTypeBaseTypeId = value?.Id || this.value.VehicleTypeBaseTypeId;
            },
        },
    },
};
</script>

<style lang="scss"></style>
